import FieldCategory from "@mapmycustomers/shared/enum/fieldModel/FieldCategory";
import IntegrationService from "@mapmycustomers/shared/enum/integrations/IntegrationService";
import { EntityTypesSupportedByIntegrations } from "@mapmycustomers/shared/types/entity";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";

import getFieldModelByEntityType from "@app/util/fieldModel/getByEntityType";

const getEntityRequiredFieldsForIntegration = (
  entityType: EntityTypesSupportedByIntegrations,
  service?: IntegrationService
): IField[] =>
  getFieldModelByEntityType(entityType).getIntegrationCategorizedFields(service)?.[
    FieldCategory.REQUIRED
  ] ?? [];

export const getEntityRequiredFieldNamesForIntegration = (
  entityType: EntityTypesSupportedByIntegrations,
  service?: IntegrationService
): Set<string> =>
  new Set(getEntityRequiredFieldsForIntegration(entityType, service).map(({ name }) => name));

export default getEntityRequiredFieldsForIntegration;
